// extracted by mini-css-extract-plugin
export default {"DegradedGlyph":"DegradedIndicator_DegradedGlyph__hw0e7"};